function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.17 15.4306V6.7866C5.16595 6.08963 5.43755 5.42566 5.92504 4.93445C6.41253 4.44324 7.076 4.16501 7.76948 4.16097L14.4574 4.16099C15.0566 4.16099 15.5424 3.67724 15.5424 3.0805C15.5424 2.48375 15.0566 2 14.4574 2H7.76314C6.4878 2.00741 5.27374 2.51653 4.38169 3.41539C3.48966 4.31421 2.9927 5.52913 3.00008 6.79288L3.00006 15.4306C3.00006 16.0273 3.48582 16.5111 4.08503 16.5111C4.68424 16.5111 5.17 16.0273 5.17 15.4306Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.113 5.94385C20.1556 5.94385 21.0009 6.78558 21.0009 7.82391V20.1199C21.0009 21.1583 20.1556 22 19.113 22H8.80581C7.76319 22 6.91797 21.1583 6.91797 20.1199V7.82391C6.91797 6.78558 7.76319 5.94385 8.80581 5.94385H19.113ZM18.8309 8.10483H9.08789V19.839H18.8309V8.10483Z",
  fill: "currentColor"
});

function SvgCopyPaste(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyPaste);
export default __webpack_public_path__ + "static/media/copy-paste.df22f446.svg";
export { ForwardRef as ReactComponent };